// ALERT LAYOUT COMPONENTS
import AllowExtensionInjection from './AllowExtensionInjection.vue';
import DefaultAlertAction from './DefaultAlertAction.vue';
import FeatureNotification from './FeatureNotification.vue';
import ModuleSharedAndTurnedOn from './ModuleSharedAndTurnedOn.vue';
import ModuleSharedRequiresSetup from './ModuleSharedRequiresSetup.vue';
import ModuleTurnedOffByError from './ModuleTurnedOffByError.vue';
import ProjectCollaboratedGoToProject from './ProjectCollaboratedGoToProject.vue';
import ReconnectCredentials from './ReconnectCredentials.vue';
import RedirectToUrl from './RedirectToUrl.vue';
import SubFlowDeletedAlert from './SubFlowDeletedAlert.vue';
import SyncedGroupTurnedOffAlert from './SyncedGroupTurnedOffAlert.vue';
import { ACTION_TYPES_MAP } from '../../../utils/alerts/action-types/action-types.const';

// CONTENT COMPONENTS
// import IFrameNotification from '@/components/common/Alerts/IFrameNotification.vue'; // THIS component is disabled for now, because the only notification from this kind is open chrome store, which cant be loaded in an Iframe
import ActionableNotificationRun from '@/components/common/Alerts/ActionableNotificationRun.vue';

const getAlertActionTypeConfiguration = (id, component) => ({ id, component });

const ALERT_ACTION_TYPES_CONFIGURATION = [
	getAlertActionTypeConfiguration(ACTION_TYPES_MAP.DEFAULT, DefaultAlertAction),
	getAlertActionTypeConfiguration(ACTION_TYPES_MAP.REDIRECT_TO_URL, RedirectToUrl),
	getAlertActionTypeConfiguration(ACTION_TYPES_MAP.FEATURE_NOTIFICATION, FeatureNotification),
	getAlertActionTypeConfiguration(ACTION_TYPES_MAP.RECONNECT_CREDENTIALS, ReconnectCredentials),
	getAlertActionTypeConfiguration(ACTION_TYPES_MAP.MODULE_TURNED_OFF_BY_ERROR, ModuleTurnedOffByError),
	getAlertActionTypeConfiguration(ACTION_TYPES_MAP.MODULE_SHARED_NEED_TURN_ON, ModuleSharedAndTurnedOn),
	getAlertActionTypeConfiguration(ACTION_TYPES_MAP.MODULE_SHARED_AND_TURNED_ON, ModuleSharedAndTurnedOn),
	getAlertActionTypeConfiguration(ACTION_TYPES_MAP.PROJECT_COLLABORATED, ProjectCollaboratedGoToProject),
	getAlertActionTypeConfiguration(ACTION_TYPES_MAP.MODULE_SHARED_REQUIRES_SETUP, ModuleSharedRequiresSetup),
	getAlertActionTypeConfiguration(ACTION_TYPES_MAP.ALLOW_EXTENSION_INJECTION_ACTION_TYPE, AllowExtensionInjection),
	getAlertActionTypeConfiguration(ACTION_TYPES_MAP.MODULE_TURNED_OFF_DUE_TO_SUB_FLOW, SubFlowDeletedAlert),
	getAlertActionTypeConfiguration(ACTION_TYPES_MAP.SYNCED_GROUP_TURNED_OFF_DUE_TO_FAILURE, SyncedGroupTurnedOffAlert),
];

export const ALERT_ACTION_TYPES_CONFIGURATIONS_MAP = ALERT_ACTION_TYPES_CONFIGURATION.reduce(
	(ALERT_ACTION_TYPES_CONFIGURATIONS_MAP, alertConf) => ({ ...ALERT_ACTION_TYPES_CONFIGURATIONS_MAP, [alertConf.id]: alertConf }),
	{}
);

export const ALERT_HANDLERS_COMPONENTS = {
	// [ACTION_TYPES_MAP.REDIRECT_TO_URL]: IFrameNotification, // THIS component is disabled for now, because the only notification from this kind is open chrome store, which cant be loaded in an Iframe
	[ACTION_TYPES_MAP.FEATURE_NOTIFICATION]: ActionableNotificationRun,
};
